









import { Prop, Component, Vue } from "vue-property-decorator";
import IReportOutput from "@/api/models/IReportOutput";
import IReportSceneOutput from "@/api/models/IReportSceneOutput";
import createReportOutput from "@/api/models/factories/createReportOutput";
import createReportSceneOutput from "@/api/models/factories/createReportSceneOutput";
import { getPhotoEntries } from "@/api/photo-api";
import { FolderEntry, Breadcrumb } from "@/models/file";

import ReportEdit from "@/templates/ReportEdit.vue";
import ReportFormData from "@/api/models/ReportFormData";
import { saveReportEntry } from "@/api/report-api";
import uploadPhoto from "../helpers/uploadPhoto";

@Component({
  components: {
    ReportEdit
  }
})
export default class ReportNewPage extends Vue {
  @Prop({ required: true }) projectId!: string;
  @Prop({ required: true }) folderId!: string;

  report!: IReportOutput;
  scenes: IReportSceneOutput[] = [];
  entries: FolderEntry[] = [];
  breadcrumbs: Breadcrumb[] = [];
  photoFolderId = "0";

  async ok() {
    const id = await this.save(this.report, this.scenes);
    this.goShowPage(String(id));
  }

  async cd(id: string) {
    this.photoFolderId = id;
    const { entries, path } = await getPhotoEntries(this.projectId, id);
    this.entries = entries;
    this.breadcrumbs = path;
  }

  async uploadPhoto(files: FileList) {
    if (!files.length) return;
    await uploadPhoto(this.projectId, this.photoFolderId, files[0]);
    this.cd(this.photoFolderId);
  }

  private created() {
    this.report = createReportOutput();
    this.report.projectId = this.projectId;
    this.report.parentFolderId = this.folderId;
    this.scenes = [createReportSceneOutput()];
  }

  private async save(report: IReportOutput, scenes: IReportSceneOutput[]) {
    const d = ReportFormData(report, scenes);
    return await saveReportEntry(d);
  }

  private goShowPage(id: string) {
    const params = {
      projectId: this.projectId,
      folderId: this.folderId,
      reportId: id
    };
    this.$router.push({ name: "report-show", params });
  }
}
